
const digest = '9cb21dee762f75a43f03b413a14164a1144ecbc9001fae959a7ef679fe04a06c';
const classes = {"wrapper":"_wrapper_19mkw_1","header":"_header_19mkw_8","title":"_title_19mkw_13","content":"_content_19mkw_17","table":"_table_19mkw_23","sidePanel":"_sidePanel_19mkw_27","genWrapper":"_genWrapper_19mkw_35","controls":"_controls_19mkw_39"};
const css = `._wrapper_19mkw_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: Rubik, "sans-serif";
  height: 100%;
}
._wrapper_19mkw_1 ._header_19mkw_8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
._wrapper_19mkw_1 ._header_19mkw_8 ._title_19mkw_13 {
  font-size: 16px;
  font-weight: 600;
}
._wrapper_19mkw_1 ._content_19mkw_17 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  height: 100%;
}
._wrapper_19mkw_1 ._content_19mkw_17 ._table_19mkw_23 {
  flex: 1;
  height: 100%;
}
._wrapper_19mkw_1 ._content_19mkw_17 ._sidePanel_19mkw_27 {
  width: 500px;
  border: 1px solid #eaedf3;
  background-color: #fff;
  padding: 24px;
  margin-top: 6px;
  height: 100%;
}
._wrapper_19mkw_1 ._content_19mkw_17 ._sidePanel_19mkw_27 ._genWrapper_19mkw_35 {
  display: flex;
  justify-content: flex-end;
}
._wrapper_19mkw_1 ._content_19mkw_17 ._sidePanel_19mkw_27 ._controls_19mkw_39 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  